export class BaseModel {
    public id: string;
    public dataInclusao: Date;
    public dataAlteracao: Date;
    public registroAtivo: boolean = true;
}
